import { createSlice } from '@reduxjs/toolkit';
const initState = {
  sidebarHidden: false,
};

export const localStorageSlice = createSlice({
  name: 'localStorage',
  initialState: initState,
  reducers: {
    clearLocalStorageToInitState: () => {
      return initState;
    },
  },
});
